import React from 'react';
import { Box, Button } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { Link } from 'react-router-dom';

import { useThemeContext } from '../../contexts/ThemeContext';

const UnauthorizedPage: React.FC = () => {
  const { theme } = useThemeContext();
  const md = useMediaQuery(theme.breakpoints.up('sm'));

  return (
    <Box sx={{ display: 'flex', textAlign: 'center', py: 4 }}>
      <Box
        sx={{
          display: 'initial',
          flexDirection: 'column',
          alignItems: 'center',
          maxWidth: 800,
          margin: 'auto',
          mt: 4,
          justifyContent: 'center',
          height: '100vh',
          gap: '1rem',
        }}
      >
        <Box sx={{ minWidth: '81%', padding: '10px' }}>
          <h1>Access Forbidden</h1>
          <p>You are not allowed to access this page.</p>

          <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', mt: 2 }}>
            <Button component={Link} to="/" variant="contained">
              Back to Home
            </Button>
            <Button component={Link} to="/support.html" variant="outlined">
              Contact Support
            </Button>
          </Box>
        </Box>
      </Box>

      {md && (
        <Box sx={{ maxWidth: '492px', maxHeight: '360px' }}>
          <img src="/images/login.png" alt="Access forbidden" style={{ maxWidth: '492px', maxHeight: '360px' }} />
        </Box>
      )}
    </Box>
  );
};

export default UnauthorizedPage;
